<template>
  <img v-if="avatar" class="w-45px h-45px rounded"
       :src="avatar"
       alt=""
       loading="lazy"
       style="object-fit: cover;"
  />

  <div v-if="!avatar" class="w-45px h-45px rounded bg-body d-flex align-items-center justify-content-center text-white">
    <i class="bi bi-person fs-4 lh-1"></i>
  </div>
</template>
<script>
export default {
  name: "UserAvatarComment",
  props: {
    avatar: {
      type: String,
      required: false,
      default: null
    }
  }
}
</script>
